// iter151 — Company Owner gate.
// The synthetic Company Owner account (is_company_owner=true) can SEE every
// create/add action but cannot perform them — Studies and Requests must be
// created by an invited Company Rep. This helper centralises that rule so
// every Create button stays clickable but raises a toast on owner.
import { toast } from 'sonner';

export function makeOwnerGate(isCompanyOwner) {
  return () => {
    if (typeof isCompanyOwner === 'function' && isCompanyOwner()) {
      toast.error(
        'Only Company Reps can create studies and requests. Please invite a rep from “Manage Reps” or ask one of your existing reps to do this for you.',
        { duration: 6000 },
      );
      return true; // blocked
    }
    return false; // proceed
  };
}
